import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {CurrencySettingModel} from '../../../../models/CurrencySettingModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CurrencySettingService} from '../service/currency-setting.service';
import * as toastr from 'toastr';
import {RegionModel} from '../../../../models/RegionModel';

@Component({
  selector: 'app-new-currency',
  templateUrl: './new-currency.component.html',
  styleUrls: ['./new-currency.component.scss']
})
export class NewCurrencyComponent extends ProjectConstants implements OnInit, OnDestroy {

  showActions: boolean;
  showRegion: boolean;
  showCurrency: boolean;

  currencySetting: CurrencySettingModel;
  regionSelect: RegionModel;
  currencySelect: CurrencyModel;
  saveCurrency: Subscription;

  registerForm: FormGroup;
  submitted = false;

  constructor(private route: ActivatedRoute, private router: Router,
              private currencySettingService: CurrencySettingService,
              private formBuilder: FormBuilder) {
    super();

    this.showActions = false;
    this.showRegion = false;
    this.showCurrency = false;
    this.currencySetting = new CurrencySettingModel();
    this.regionSelect = new RegionModel();
    this.currencySelect = new CurrencyModel();
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      regionCod: [{value: '', disabled: false}, Validators.required],
      currencyCod: [{value: '', disabled: false}, Validators.required]
    });
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 3}});
  }

  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      event.preventDefault();
      this.saveCurrency = this.currencySettingService.save(this.currencySettingService.baseUrl, this.currencySetting)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, Region already exists', 'Warning');
            } else {
              toastr.success('Currency Setting was created with success', 'Success');
              this.router.navigate([this.LINKS.SETTINGS], {queryParams: {selectedIndex: 3}});
            }
          },
          error => {
            toastr.error('Currency Setting was not created', 'Error');
          });
    }
  }

  ngOnDestroy(): void {
    if (this.saveCurrency) {
      this.saveCurrency.unsubscribe();
    }
  }

  getElementSelectedRegion($event) {
    this.currencySetting.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      regionCod: this.regionSelect.cod
    });
  }

  getElementSelectedCurrency($event) {
    this.currencySetting.currency = $event.row;
    this.currencySelect = $event.row;
    this.registerForm.patchValue({
      currencyCod: this.currencySelect.cod
    });
  }

  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  toggleCurrency() {
    this.showCurrency = !this.showCurrency;
  }

  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


  resetRegion() {
    this.registerForm.patchValue({
      regionCod: ''
    });
    this.regionSelect = new RegionModel();
  }

  resetCurrency() {
    this.registerForm.patchValue({
      currencyCod: ''
    });
    this.currencySelect = new CurrencyModel();
  }
}
